<template>
  <div id="app" :style="colorTheme">
    <router-view/>
  </div>
</template>

<script>



  export default {
    name: 'app',
    data: function () {
      return {
        colorTheme: "",
        lang: "",
      }
    },

    methods: {
      async loadData() {
        try {
          this.colorTheme = await this.$store.dispatch('callApi', {
            name: 'getColorTheme'
          });
          console.log('barevné schéma'+this.colorTheme);
        } catch (e){
          console.error(e);
        }
      },
      async getUser() {
        try {
          this.lang = await this.$store.dispatch('callApi', {
            name: 'getUser'
          });
          this.$i18n.locale = this.lang.language;
        } catch (e){
          console.error(e);
        }
      },
    },
    created() {
      this.$eventHub.$on('refreshColorTheme',this.loadData);
    },
    async mounted() {
      await this.loadData();
      await this.getUser();
    }
  }
</script>

<style lang="less">
@import "styles/screen.less";


</style>
